// extracted by mini-css-extract-plugin
module.exports =  {"alert":"j6_5P4U1qsyw3v7Rewxb"};